import type { AllRouteEndpoints } from "../routeTypes";

export const productAlertOverrides = "/product_alerts/overrides";
export const productAlertOverridesAlertIdCanvasId = "/product_alerts/overrides/:alert_id/:canvas_id";

/** Saving an override changes which alerts the Canvas is excluded from. */
export const productAlertOverridesAlertIdCanvasIdCacheKeys: AllRouteEndpoints[] = [productAlertOverrides];
